
import { Component, EventEmitter, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { take } from 'rxjs/operators';
import { ListAddressesUserService } from './service/list-addresses-user.service';
import { Adresses } from './interfaces/addresses-user.interface';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AuthService } from '../../../../../core/service/auth.service';
import { SelectedAddressService } from '../../../../../core/service/selected-address.service';
import { Subscription } from 'rxjs';
import { ShopCartService } from '../../../shop-cart/service/shop-cart.service';
import { SyncPricesCartService } from '../../../../../core/service/sync-prices-cart/sync-prices-cart.service';
import { ModalViewLocationService } from '../../service/modal-view-location.service';
import { PrePurchaseService } from '../../../../../core/service/pre-purchase/pre-purchase.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../store/app.state';
import { setLocation } from '../../../../../store/location/location.actions';
import { selectIsCartEmpty } from '../../../../../store/cart/cart.selectors';
import { NotificationsService } from '../../../notifications/service/notifications.service';

@Component({
  selector: 'modal-view-location-list-addresses',
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './list-addresses.component.html',
  styleUrl: './list-addresses.component.css'
})
export class ListAddressesComponent implements OnInit {
  addresses: Adresses[] = [];
  isLoading = true;
  errorMessage = '';
  selectedId: number | null = null;
  private refreshSubscription: Subscription | null = null;
  constructor(
    private listAddressesUserService: ListAddressesUserService,
    private authService: AuthService,
    private selectedAddressService: SelectedAddressService,
    private shopCartService: ShopCartService,
    private syncPricesCartService: SyncPricesCartService,
    private modalViewLocationService: ModalViewLocationService,
    private prePurchaseService: PrePurchaseService,
    private store: Store<AppState>,
    private notificationsService: NotificationsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadAddressesUser();

    // Subscribe to refresh events
    this.refreshSubscription = this.listAddressesUserService.getRefreshAddressesObservable()
      .subscribe(() => {
        // console.log('Refresh event received, reloading addresses...');
        this.loadAddressesUser();
      });
    this.modalViewLocationService.setEditMode(false);
  }

  loadAddressesUser(): void {
    const user = this.authService.getUser();
    if (!user) {
      this.errorMessage = 'No estás logueado';
      this.isLoading = false;
      this.cdr.detectChanges();
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.cdr.detectChanges();
    
    this.listAddressesUserService.getAddresses(user.ua_id).subscribe({
      next: (response) => {
        this.addresses = response.data;
        this.isLoading = false;
        this.cdr.detectChanges();
        
        // Select first address by default if available
        if (this.addresses.length > 0) {
          // Check if there's already a selected address in the service
          const currentSelected = this.selectedAddressService.getCurrentSelectedAddress();
          if (!currentSelected) {
            this.selectAddress(this.addresses[0]);
          } else {
            // Set the selectedId to match the currently selected address
            this.selectedId = currentSelected.ad_id;
          }
        }
      },
      error: (error) => {
        console.error('Error fetching addresses:', error);
        this.errorMessage = 'Error al obtener las direcciones';
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  selectAddress(address: Adresses): void {
    this.selectedId = address.ad_id;
    // Store the selected address in the service
    this.selectedAddressService.setSelectedAddress(address);

    // Update location in store
    const latitude = parseFloat(address.ad_latitude);
    const longitude = parseFloat(address.ad_longitude || '0');
    this.store.dispatch(setLocation({ latitude, longitude }));

    // Call the API to sync prices cart and purchase cart asynchronously
    if (this.shopCartService) {
      // Check if cart is empty before calling prePurchaseService
      this.store.select(selectIsCartEmpty).pipe(take(1)).subscribe(isEmpty => {
        if (!isEmpty) {
          // Only call prePurchaseService if cart is not empty
          this.prePurchaseService.getCoordinates().subscribe(coordinates => {
            if (coordinates) {
              // console.log('coordinates', coordinates);
            }
          });
        }
      });
      
      // this.shopCartService.syncPricesCart();
      // this.syncPricesCartService.purchaseCart().subscribe({
      //   next: () => {
      //     console.log('Cart data refreshed after selecting new address');
      //   },
      //   error: (error) => {
      //     console.error('Error refreshing cart data:', error);
      //   }
      // });
    }

    // Cerrar el modal después de seleccionar la dirección
    this.modalViewLocationService.toggleModal(false);
  }
  onDeleteAddress(event: Event, addressId: number) {
    event.stopPropagation();
    this.isLoading = true;
    this.cdr.detectChanges();
    this.listAddressesUserService.deleteAddress(addressId).subscribe({
      next: (respose) => {
        this.loadAddressesUser();
        this.selectedAddressService.clearSelectedAddress();
        this.selectedAddressService.getSelectedAddress();
        this.notificationsService.addNotification({
            message: respose.message,
            type: "success",
            duration: 5000
          });
      },
      error: (error) => {
        this.errorMessage = error.message || 'Error al eliminar la dirección';
        this.isLoading = false;
        this.cdr.detectChanges();
        this.notificationsService.addNotification({
            message: error.error?.message || 'Error al eliminar la dirección',
            type: "error",
            duration: 5000
          });
      }
    });
  }
  ngOnDestroy(): void {
    // Clean up subscription to prevent memory leaks
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

  onEditAddress(event: Event,address: Adresses){
    event.stopPropagation();
    // this.showMap = false;
    this.modalViewLocationService.sendAddress(address);
    this.modalViewLocationService.setEditMode(true);
    this.modalViewLocationService.showMap(true);
  }
}
